import ApiService from "../services/api";

export const fetchAlerts = async (body: any): Promise<any[]> => {
  const apiService = new ApiService(import.meta.env.VITE_ALERTS_URL, 'rio-maintenance');
  try {
    const response = await apiService.post<any>(`/faultCodes`, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.status === 200) {
      return response.data?.data ?? [];
    } else {
      return [];
    }
  } catch (error) {
    console.error("Erro ao buscar alertas:", error);
    return [];
  }
};
